import React, { FC } from "react";
import { YouTube, X, Instagram, LinkedIn } from "@app/components/common/icons";
import { useSiteData } from "@app/hooks";

export const SocialMedia: FC = () => {
  const siteData = useSiteData();

  const socialLinks = [
    {
      icon: <YouTube />,
      link: siteData.youtubeLink,
      label: "Alpian on YouTube",
    },
    {
      icon: <LinkedIn />,
      link: siteData.linkedInLink,
      label: "Alpian on LinkedIn",
    },
    {
      icon: <X />,
      link: siteData.twitterLink,
      label: "Alpian on X",
    },
    {
      icon: <Instagram />,
      link: siteData.instagramLink,
      label: "Alpian on Instagram",
    },
  ];

  return (
    <div className={"flex items-center gap-x-7.5"}>
      {socialLinks.map((link, i) => (
        <a
          key={`social-link-${i}`}
          href={link.link}
          target="_blank"
          rel="noopener noreferrer"
          className="cursor-pointer"
          aria-label={link.label}
        >
          {link.icon}
        </a>
      ))}
    </div>
  );
};
